const locale = {
  id: 'PosterConstant',
  code: 'CN',
  text: {
    "./images/poster_en@2x.png": "./images/poster@2x.png",
    "Create a Beautiful Poster Design Is Simple": '无需设计师也能制作精美营销海报',
    "Not only will you be able to create a beautiful poster to share, it can also be used to sign up classes and activities, buying event tickets, and published surveys. Posters can be saved as a draft, or published and shared on WeChat, Facebook, and Twitter. Let's get started!": '不仅能排出精美的宣传海报，还附带各种报名功能，如课程/班级的报名注册，活动的报名，在线售票，以及调查问卷，制作好的海报可以存为草稿定时发布和分享到 Wechat, Facebook and Twitter 上。还等什么，快来体验吧',
  }
}

export const onBoardingContents = {
  // we show this when student state is 'current'
  all: {
    title: __('Create a Beautiful Poster Design Is Simple', locale),
    text: __("Not only will you be able to create a beautiful poster to share, it can also be used to sign up classes and activities, buying event tickets, and published surveys. Posters can be saved as a draft, or published and shared on WeChat, Facebook, and Twitter. Let's get started!", locale),
    image: require(__('./images/poster_en@2x.png', locale)),
    showArrow: true,
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/constant.js